import DOMPurify from "dompurify";

const valueOf = (element, ...keys) => {
  for (const key of keys) {
    if (element[key] !== undefined && element[key] !== null) return element[key];
    if (element.props && element.props[key] !== undefined && element.props[key] !== null) return element.props[key];
    if (element.settings && element.settings[key] !== undefined && element.settings[key] !== null) return element.settings[key];
  }
  return "";
};

export default function LandingRenderer({ page, preview = false }) {
  const elements = page.elements || page.content || [];
  const render = (element, index) => {
    if (!element || typeof element !== "object") return null;
    const type = String(element.type || "").toLowerCase();
    const key = element.id || `${type}-${index}`;
    const text = valueOf(element, "text", "content", "title");
    const style =
      typeof element.style === "object" && element.style !== null
        ? element.style
        : typeof element.styles === "object" && element.styles !== null
        ? element.styles
        : {};
    if (type === "heading") {
      const level = Math.min(6, Math.max(1, Number(valueOf(element, "level")) || 2));
      const Tag = `h${level}`;
      return (
        <Tag key={key} className="landing-heading" style={style}>
          {text}
        </Tag>
      );
    }
    if (type === "paragraph")
      return (
        <div
          key={key}
          className="landing-paragraph"
          style={style}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
        />
      );
    if (type === "image")
      return (
        <figure key={key} className="landing-image" style={style}>
          <img src={valueOf(element, "src", "url", "image")} alt={valueOf(element, "alt", "caption") || ""} />
          {valueOf(element, "caption") && <figcaption>{valueOf(element, "caption")}</figcaption>}
        </figure>
      );
    if (type === "testimonials" || type === "testimonial") {
      const testimonials = valueOf(element, "items", "testimonials") || [element];
      return (
        <div key={key} className="landing-testimonials" style={style}>
          {testimonials.map((item, i) => (
            <blockquote key={item.id || i}>
              <p>{item.text || item.content || item.quote}</p>
              {(item.name || item.author) && <footer>— {item.name || item.author}</footer>}
            </blockquote>
          ))}
        </div>
      );
    }
    if (type === "button") {
      const label = text || valueOf(element, "label") || "Selengkapnya";
      const url = valueOf(element, "url", "href", "link") || "#checkout";
      return (
        <div key={key} className="landing-button-wrap" style={style}>
          {preview ? (
            <span className="landing-button-anchor">{label}</span>
          ) : (
            <a href={url}>{label}</a>
          )}
        </div>
      );
    }
    if (type === "list") {
      const items = valueOf(element, "items") || [];
      const Tag = valueOf(element, "ordered") ? "ol" : "ul";
      return (
        <Tag key={key} className="landing-list" style={style}>
          {items.map((item, i) => (
            <li key={item.id || i}>
              {typeof item === "string" ? item : item.text || item.content || item.label}
            </li>
          ))}
        </Tag>
      );
    }
    return null;
  };
  const width = Math.min(960, Math.max(800, Number(page.width || page.content_width || (page.settings && page.settings.width)) || 900));
  return (
    <main className="landing-shell">
      <article className="landing-content" style={{ maxWidth: width }}>
        {elements.map(render)}
      </article>
    </main>
  );
}
